import { Link } from "react-router-dom";
import ExternalLink from "@/components/ui/ExternalLink";
import InfoPageLayout from "@/components/templates/infoPage/InfoPageLayout";
import InfoPageSection from "@/components/templates/infoPage/InfoPageSection";
import {
  InfoPageList as Ul,
  InfoPageListItem as Li,
} from "@/components/templates/infoPage/InfoPageList";
import OfficialLINE from "@/components/ui/OfficialLINE";
import { OFFICIAL_EMAIL, OFFICIAL_LINE } from "@/constants/common";

const TermsOfServicePage = () => {
  const lastUpdated = new Date().toISOString().slice(0, 10);

  return (
    <InfoPageLayout
      pageTitle="服務條款"
      bannerImage={{
        default: "/images/banner-shopping-info.jpg",
        desktop: "/images/banner-shopping-info.jpg",
      }}
      breadcrumbs={[{ label: "首頁", path: "/" }, { label: "服務條款" }]}
      ogImage="/images/banner-shopping-info-og.jpg"
      bannerImagAlign="right"
    >
      <p>
        歡迎使用小院咖啡（以下稱「本網站」）之服務。當您於本網站瀏覽、將商品加入購物車、結帳、完成訂單或使用
        LINE／Email 聯繫客服，即表示您已閱讀、瞭解並同意本服務條款及相關政策之內容。
      </p>

      <InfoPageSection title="適用範圍">
        <Ul>
          <Li>本條款適用於本網站所提供之購物、結帳、訂單查詢、售後與客服聯繫等服務。</Li>
          <Li>
            關於個人資料之蒐集與使用，請同時參考
            <Link to="/privacy-policy" className="brand-link-with-underline">
              隱私權政策
            </Link>
            。
          </Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="訂購與帳戶">
        <Ul>
          <Li>無需註冊會員亦可下單，請務必提供正確且可聯繫之姓名、電話、Email 與收件地址。</Li>
          <Li>
            完成下單後，系統會寄送訂單通知至您填寫之 Email；如未收到，請先檢查垃圾信件匣或透過{" "}
            <OfficialLINE /> 聯繫。
          </Li>
          <Li>本網站保留是否接受訂單之權利（例如：庫存不足、系統異常或不當訂購等）。</Li>
          <Li>
            如需修改訂單內容，請儘速透過 <OfficialLINE /> 聯繫，我們將依處理進度協助。
          </Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="商品與價格">
        <Ul>
          <Li>商品資訊以網站頁面為準，標示之價格已包含必要稅額（如適用）。</Li>
          <Li>促銷、折扣與免運活動之條件以各活動頁面或結帳顯示為準。</Li>
          <Li>若因排版或系統錯誤致使價格或規格顯示異常，本網站保留取消或更正訂單之權利。</Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="付款方式" id="payment-methods">
        <Ul>
          <Li>信用卡（Visa / Master / JCB，透過綠界金流 ECPay 處理）。</Li>
          <Li>超商取貨付款。</Li>
          <Li>
            銀行轉帳：轉帳完成後請加入 <OfficialLINE /> 主動提供轉帳後 5
            碼；經確認入帳後安排烘焙與出貨。
          </Li>
        </Ul>
        <p>信用卡資料由金流服務商安全處理，本網站不會接觸或儲存您的完整信用卡資料。</p>
      </InfoPageSection>

      <InfoPageSection title="出貨與配送" id="shipping-methods">
        <Ul>
          <Li>超商取貨：7-11、全家、萊爾富（一般 2–3 日送達）。</Li>
          <Li>郵局宅配（一般 2–3 日送達）。</Li>
          <Li>
            目前僅寄送台灣本島；外島寄送請先透過 <OfficialLINE /> 詢問可行性與運費。
          </Li>
        </Ul>
        <p>如遇天候或物流量暴增等因素，配送時程可能延後，敬請見諒。</p>
      </InfoPageSection>

      <InfoPageSection title="運費與未取件" id="shipping-fee">
        <p>
          滿額免運與各配送通路之運費，請參考
          <Link to="/shopping-info#shipping-fee" className="brand-link-with-underline">
            購物說明
          </Link>
          。
        </p>
        <Ul>
          <Li>如選擇超商取貨，無故未取所產生之往返運費與相關成本，將由您自行負擔。</Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="訂單變更、取消與退換貨">
        <Ul>
          <Li>咖啡豆多為新鮮烘焙，若已進入烘焙或出貨流程，可能無法變更或取消訂單。</Li>
          <Li>
            退換貨規範與流程，請詳見
            <Link to="/return-policy" className="brand-link-with-underline">
              退換貨說明
            </Link>
            ，下單前請先閱讀以保障您的權益。
          </Li>
          <Li>
            若您收到之商品有瑕疵或與訂單不符，請於可合理期間內透過 <OfficialLINE /> 或 Email（
            {OFFICIAL_EMAIL}）與我們聯繫。
          </Li>
        </Ul>
      </InfoPageSection>

      {/* <InfoPageSection title="發票與帳務">
        <Ul>
          <Li>
            本網站將依法開立發票或等值憑證；若需協助，請透過 <OfficialLINE /> 與我們聯繫。
          </Li>
        </Ul>
      </InfoPageSection> */}

      <InfoPageSection title="服務中斷與免責">
        <Ul>
          <Li>
            本網站可能因系統維護、異常或不可抗力因素而暫停或中斷服務，我們將盡速恢復並於可能情形下事前或事後公告。
          </Li>
          <Li>
            因第三方服務（如金流、物流、網站分析工具等）所致之延誤或不可歸責本網站之因素，將協助溝通處理，但不負遲延之賠償責任。
          </Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="智慧財產權">
        <Ul>
          <Li>
            本網站之文字、圖像、標誌與設計等，受著作權與相關法律保護。未經授權，請勿擅自使用、重製或散佈。
          </Li>
          <Li>
            部分網站圖片素材取自 Unsplash、Flaticon
            免費圖片平台，並依各平台授權規範使用。如您對圖片來源有疑問，歡迎與我們聯繫。
          </Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="隱私與資料保護">
        <p>
          我們重視您的個人資料，相關蒐集、使用與保護，請參考
          <Link to="/privacy-policy" className="brand-link-with-underline">
            隱私權政策
          </Link>
          。
        </p>
      </InfoPageSection>

      <InfoPageSection title="聯絡我們" id="contact">
        <Ul>
          <Li>
            LINE 官方帳號：
            <ExternalLink href={OFFICIAL_LINE.LINK}>{OFFICIAL_LINE.AT_ID}</ExternalLink>
          </Li>
          <Li>E-mail：{OFFICIAL_EMAIL}</Li>
        </Ul>
      </InfoPageSection>

      <InfoPageSection title="條款更新">
        <p>本條款將視法令與服務需要適時修訂並公告於本頁。最後更新日期：{lastUpdated}</p>
      </InfoPageSection>
    </InfoPageLayout>
  );
};

export default TermsOfServicePage;
